/* eslint-disable import/no-anonymous-default-export */
import { ListFilterSidebar } from '@/components/filters/ListFilterSidebar';

export const RoleListFilter = () => (
    <ListFilterSidebar searchPlaceholder="Search by name" />
);
